function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.063 2h9.874l-.735 12H3.798L3.063 2z",
  stroke: "currentColor",
  strokeWidth: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 3H0V1.3A.3.3 0 0 1 .3 1h15.4a.3.3 0 0 1 .3.3V3z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.4 0a.6.6 0 0 1 .6.6v.8a.6.6 0 0 1-.6.6h-.8a.6.6 0 0 1-.6-.6V.6a.6.6 0 0 1 .6-.6h.8z",
  fill: "currentColor"
});

const SvgBin = props => React.createElement("svg", _extends({
  viewBox: "0 0 16 15",
  fill: "none"
}, props), _ref, _ref2, _ref3);

export default SvgBin;